import React from 'react';
import { LegalPage } from './LegalPage';

export const AffiliateTermsPage = () => <LegalPage page="affiliateTerms" />;
